import { Switch } from "@mui/joy";
import { useLocalStorageState } from "ahooks";
import { memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  portalTypeStorageKeyName,
  restorePortalToStorageKeyName,
} from "features/dmp/constants";
import { PortalType } from "features/dmp/types";
import { useOrganizationPreferences } from "hooks";

const PlatformSwitch = memo(() => {
  const { enableDmp } = useOrganizationPreferences();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [portalType, setPortalType] = useLocalStorageState<string>(
    portalTypeStorageKeyName,
    { defaultValue: PortalType.DCR, listenStorageChange: true }
  );
  const [restorePortalTo, setRestorePortalTo] = useLocalStorageState<
    string | undefined
  >(restorePortalToStorageKeyName, { defaultValue: undefined });
  return enableDmp ? (
    <Switch
      checked={portalType === PortalType.PAP}
      color="neutral"
      onChange={(event) => {
        const restoreTo = pathname;
        setPortalType(event.target.checked ? PortalType.PAP : PortalType.DCR);
        navigate(
          restorePortalTo || (event.target.checked ? "/pap/audiences" : "/")
        );
        setRestorePortalTo(restoreTo);
      }}
      slotProps={{
        thumb: {
          children: portalType === PortalType.PAP ? "PAP" : "DCR",
          sx: {
            color: "white !important",
            fontSize: "0.75rem",
            textTransform: "capitalize",
          },
        },
      }}
      sx={{
        "& .MuiSwitch-thumb": {
          "&.Mui-checked": {
            backgroundColor: "white",
          },
          backgroundColor: "white",
          border: "1px solid",
          borderColor: "var(--Switch-trackBorderColor)",
          color: "var(--joy-palette-neutral-outlinedColor) !important",
          fontSize: "0.75rem",
          fontWeight: 600,
        },
        "& .MuiSwitch-track": {
          "&.Mui-checked": {
            "--variant-borderWidth": "unset",
            backgroundColor: "var(--joy-palette-background-surface)",
          },
        },
        "&:hover": {
          "& .MuiSwitch-track": {
            "&.Mui-checked": {
              backgroundColor: "var(--joy-palette-neutral-outlinedHoverBg)",
            },
          },
        },
        "--Switch-thumbSize": "24px",
        "--Switch-thumbWidth": "40px",
        "--Switch-trackHeight": "32px",
        "--Switch-trackWidth": "60px",
      }}
      variant="outlined"
    />
  ) : null;
});
PlatformSwitch.displayName = "PlatformSwitch";

export default PlatformSwitch;
